import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { LinkCarousel } from '../components/LinkCarousel';
import { carouselLinkClick, carouselVisible } from '../modules/actions';
import { selectRelatedCategories } from '../modules/selectors';

export const mapStateToProps = (state: ReduxApplicationState) => ({
  links: selectRelatedCategories(state),
});

export const mapDispatchToProps = {
  onCarouselVisible: carouselVisible,
  onLinkClick: carouselLinkClick,
};

export const LinkCarouselContainer = connect(mapStateToProps, mapDispatchToProps)(LinkCarousel);
